import styled from 'styled-components';
import { Menu, Avatar } from 'antd';

export const CustomMenu = styled(Menu)`
    border: none;
`;


export const CustomAvatar = styled(Avatar)`
    border: 1px solid;
    border-radius: 50%;
    padding: 5px;
    height: 48px;
    width: 48px;
    background-color: transparent;
    transition: none;
`;
